import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          // Resting cards take `raised`, not `floating`: the shadow scale reserves 5–12 for things
          // that genuinely hover over the page (menus, popovers). A card sitting in the layout gets
          // the shallow step, and CardBase's hover raises it to shadows[8] as the interaction cue.
          boxShadow: theme.shadows[1],
          borderRadius: Number(theme.shape.borderRadius),
          zIndex: 0, // Fix Safari overflow: hidden with border radius
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2', marginTop: theme.spacing(0.5) },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3),
        },
      },
    },
  }
}
